<div class="add-product-responsive p-g-12">
   <app-confirm-dialog
      [visible]="confirmationDialogVisible"
      variant="secondary"
      heading="Confirmation"
      [message]="confirmationDialogMessage"
      cancelText="No"
      (confirmed)="confirmConfirmationDialog()"
      (cancelled)="cancelConfirmationDialog()">
   </app-confirm-dialog>
   <div class="p-g-12">

      <p-tabView>

         <div class="p-g">

            <div class="p-g-12">
               <form>
                  <div class="p-g-12" class="p-toolbar-tecfolk-fix">
                     <p-toolbar>
                        <div class="p-toolbar-group-left productDetailsButton p-toolbar-tecfolk-fix">

                           <button (click)="goBack()" pButton type="button"
                              [label]='setLabel("goBackBtnLabel")' icon="pi pi-arrow-left"></button>
                           <button routerLink="/product" pButton type="button" style="background-color: #5192d0"
                              [label]='setLabel("newBtnLabel")' icon="pi pi-plus"></button>
                           <button id="saveButton" pButton type="button" [disabled]="!addEditProductsForm.valid"
                              (click)="save()" *ngIf="mode == 'add'" [label]='setLabel("saveBtnLabel")'
                              icon="pi pi-save" class="p-button-success">
                           </button>
                           <button id="updateButton" pButton type="button" [disabled]="!addEditProductsForm.valid"
                              (click)="update()" *ngIf="mode == 'edit'" [label]='setLabel("updateBtnLabel")'
                              icon="pi pi-save" class="p-button-success">
                           </button>
                           <button pButton type="button" style="background-color: #b1df0a;"
                              [disabled]="!addEditProductsForm.valid" (click)="openAddStockBox()"
                              *ngIf="mode == 'edit' && selectedProductType !== 'Ingredients Based'"
                              [label]='setLabel("addStockBtnLabel")' icon="pi pi-save">
                           </button>
                           <button pButton type="button" style="background-color: #dfa60a;"
                              [disabled]="!addEditProductsForm.valid" (click)="openRemoveStockBox()"
                              *ngIf="mode == 'edit' && selectedProductType !== 'Ingredients Based'"
                              [label]='setLabel("removeStockBtnLabel")' icon="pi pi-save">
                           </button>

                        </div>
                     </p-toolbar>
                  </div>

                  <p-tabView [activeIndex]="tabIndex" (onChange)="handleTabChange($event)">
                     <p-tabPanel [header]='setLabel("productInfoLabel")' leftIcon="fa fa-tag">
                        <div class="card card-w-title">

                           <div class="profileImgContainer">
                              <div class="p-g-12 p-lg-4 imgstyle">
                                 <img style="width:50%;"
                                    [src]="getProductImageUrl(Product.imagePath)"
                                    onerror="this.src = 'assets/layout/images/gymSupplimentAvatar.png'" />
                              </div>
                              <div class="userDetailToolBar">
                                 <h3 class="first">{{setLabel("productImageLabel")}}</h3>
                                 <button (click)="captureImageDialogShow('Cam')" style="width: auto;">
                                    <span class="ui-button-text ui-c">
                                       <i class="fa fa-camera" aria-hidden="true"></i>
                                       &nbsp;{{setLabel("captureLabel")}}
                                    </span>
                                 </button>
                                 <button (click)="captureImageDialogShow('Upload')" style="width: auto;">
                                    <span class="ui-button-text ui-c">
                                       <i class="fa fa-upload" aria-hidden="true"></i>
                                       &nbsp;{{setLabel("uploadImageLabel")}}
                                    </span>
                                 </button>
                                 <button (click)="removeProfileImage()" style="width: auto;" class="removePhoto">
                                    <span class="ui-button-text ui-c">
                                       <i class="fa fa-times"></i> &nbsp;{{setLabel("removeImageLabel")}}
                                    </span>
                                 </button>

                              </div>
                           </div>

                           <div class="p-g-12">
                              <form class="Product-Details-Form" style="display: flex;
                              flex-direction: column;" #addEditProductsForm="ngForm">

                                 <div class="p-g-12 p-md-6" style="text-align: left">

                                    <div class="p-g p-fluid">

                                       <h3 class="first">{{setLabel("productDetailsLabel")}} </h3>
                                       <div class="p-g-12" *ngIf="mode == 'edit'">
                                          <div class="p-g-12 p-inputgroup">
                                             <span class="tag p-inputgroup-addon"
                                                [pTooltip]='setLabel("codeTooltipLabel")' tooltipPosition="top"><i
                                                   class="fa fa-tag" aria-hidden="true"></i></span>
                                             <input class="" type="text" readonly
                                                [placeholder]='setLabel("codePlaceholderLabel")' name="Code"
                                                [(ngModel)]="Product.code">
                                          </div>
                                       </div>

                                       <div class="p-g-12">

                                          <div class="p-inputgroup">
                                             <span class="info p-inputgroup-addon"
                                                [pTooltip]='setLabel("nameTooltipLabel")' tooltipPosition="top"><i
                                                   class="fa fa-info" aria-hidden="true"></i></span>
                                             <input type="text" id="productName" #productName
                                                [placeholder]='setLabel("name*PlaceholderLabel")' name="name"
                                                [ngClass]="Name.invalid && (Name.dirty || Name.touched) ? 'errorInput' : '' "
                                                [(ngModel)]="Product.name" #Name="ngModel" required>
                                          </div>

                                       </div>

                                       <div class="p-g-12">
                                          <div class="product-type-row">
                                             <div class="product-type-row-item">
                                                <label class="dropdown-field-label">{{setLabel("productTypeLabel")}}</label>
                                                <div class="p-inputgroup">
                                                   <span class="p-inputgroup-addon" [pTooltip]='setLabel("typeTooltipLabel")'
                                                      tooltipPosition="top">
                                                      <i class="fa fa-list" aria-hidden="true"></i>
                                                   </span>
                                                   <p-dropdown id="typeDd" [(ngModel)]="selectedProductType"
                                                      name="productType" [options]="sourceTypes"
                                                      [style]="{'width':'100%','font-size':'14px'}" optionLabel="label"
                                                      optionValue="value" appendTo="body"
                                                      [placeholder]='setLabel("selectProductPlaceholderLabel")'>
                                                   </p-dropdown>
                                                </div>
                                             </div>
                                             <div class="product-type-row-item">
                                                <label class="dropdown-field-label">{{setLabel("productCategoryLabel")}}</label>
                                                <div class="p-inputgroup">
                                                   <span class="p-inputgroup-addon"
                                                      [pTooltip]='setLabel("categoryTooltipLabel")' tooltipPosition="top"><i
                                                         class="fa fa-list" aria-hidden="true"></i></span>
                                                   <p-dropdown
                                                      id="catagoryDd"
                                                      [options]="sourceCategories"
                                                      [(ngModel)]="selectedProductCategory"
                                                      name="productCatagory"
                                                      placeholder="Select Product Category"
                                                      optionLabel="name"
                                                      optionValue="name"
                                                      appendTo="body"
                                                      [style]="{ 'width': '100%', 'font-size': '14px' }">
                                                   </p-dropdown>
                                                </div>
                                             </div>
                                             <div class="product-type-row-item product-type-row-item-role">
                                                <label class="dropdown-field-label">{{setLabel("productRoleLabel")}}</label>
                                                <div class="p-inputgroup">
                                                   <span class="p-inputgroup-addon"
                                                      [pTooltip]='setLabel("roleTooltipLabel")' tooltipPosition="top"><i
                                                         class="fa fa-user" aria-hidden="true"></i></span>
                                                   <p-dropdown
                                                      id="roleDd"
                                                      [options]="productRoles"
                                                      [(ngModel)]="selectedProductRole"
                                                      name="productRole"
                                                      optionLabel="label"
                                                      optionValue="value"
                                                      [placeholder]='setLabel("selectRolePlaceholderLabel")'
                                                      appendTo="body"
                                                      [style]="{ 'width': '100%', 'font-size': '14px' }"
                                                      [showClear]="true">
                                                   </p-dropdown>
                                                </div>
                                             </div>
                                          </div>
                                       </div>

                                       <div class="p-g-12">
                                          <div class="p-inputgroup">
                                             <span class="p-inputgroup-addon"
                                                [pTooltip]='setLabel("descriptionTooltipLabel")'
                                                tooltipPosition="top"><i class="fa fa-pencil-square-o"
                                                   aria-hidden="true"></i></span>
                                             <textarea rows="6" id="description" cols="67" name="description"
                                                [(ngModel)]="Product.description"
                                                [placeholder]='setLabel("descriptionPlaceholderLabel")'></textarea>
                                          </div>
                                       </div>

                                    </div>
                                 </div>

                                 <div class="p-g-12 p-md-6" style="text-align: left">
                                    <h3 *ngIf="selectedProductType !== 'Ingredients Based'" class="first">
                                       {{setLabel("inventoryLabel")}}
                                       <span style="color: red;">*</span>
                                    </h3>

                                    <div class="p-g p-fluid" *ngIf="selectedProductType !== 'Ingredients Based'">
                                       <div class="p-g-12">
                                          <div class="p-inputgroup">
                                             <span class="p-inputgroup-addon"
                                                [pTooltip]='setLabel("totalStockQuantityTooltipLabel")'
                                                tooltipPosition="top">
                                                <i class="fa fa-bars" aria-hidden="true"></i>
                                             </span>
                                             <input type="number" id="totalQuantity" autocomplete="off"
                                                [placeholder]='setLabel("totalStockQuantity*PlaceholderLabel")'
                                                [ngClass]="TotalQuantity.invalid && (TotalQuantity.dirty || TotalQuantity.touched) ? 'errorInput' : '' "
                                                #TotalQuantity="ngModel" [(ngModel)]="Product.totalQuantity"
                                                oninput="this.value=Math.max(0,this.value);" name="totalQuantity"
                                                required [attr.readonly]="mode === 'add' ? null : true">
                                          </div>
                                       </div>
                                    </div>
                                    <div class="p-g p-fluid" *ngIf="selectedProductType !== 'Ingredients Based'">
                                       <div class="p-g-12">
                                          {{ displayInventory }}
                                       </div>
                                    </div>
                                    <h3 *ngIf="selectedProductType == 'Ingredients'" class="first">
                                       {{setLabel("unitLabel")}} <span style="color: red;">*</span></h3>

                                    <div class="p-g p-fluid" *ngIf="selectedProductType == 'Ingredients'">
                                       <div class="p-g-12">
                                          <div class="p-inputgroup">
                                             <span class="p-inputgroup-addon" [pTooltip]='setLabel("unitTooltipLabel")'
                                                tooltipPosition="top">
                                                <i class="fa fa-list" aria-hidden="true"></i>
                                             </span>
                                             <p-dropdown id="UnitDd" [(ngModel)]="selectedProductUnit"
                                                name="productUnit" [options]="sourceUnits"
                                                [style]="{'width':'141%','font-size':'14px'}" optionLabel="label"
                                                optionValue="value" appendTo="body"
                                                [placeholder]='setLabel("selectMeasurementPlaceholderLabel")'>
                                             </p-dropdown>
                                          </div>
                                       </div>
                                    </div>

                                    <h3 class="first">{{setLabel("cost&PriceLabel")}} <span style="color: red;">*</span>
                                    </h3>
                                    <div class="p-g p-fluid">

                                       <div class="p-g-12">
                                          <div class="p-inputgroup">
                                             <span class="p-inputgroup-addon"
                                                [pTooltip]='setLabel("purchasePriceTooltipLabel")'
                                                tooltipPosition="top"><i class="fa fa-money"
                                                   aria-hidden="true"></i></span>
                                             <input type="number" id="purchasePrice" autocomplete="off"
                                                [placeholder]='setLabel("purchasePricePlaceholderLabel")' name="cost"
                                                [(ngModel)]="Product.cost"
                                                oninput="this.value=Math.max(0,this.value);">
                                          </div>
                                       </div>

                                       <div class="p-g-12">
                                          <div class="p-inputgroup">
                                             <span class="p-inputgroup-addon"
                                                [pTooltip]='setLabel("salePriceTooltipLabel")' tooltipPosition="top"><i
                                                   class="fa fa-money" aria-hidden="true"></i></span>
                                             <input type="number" id="normalPrice" autocomplete="off"
                                                [placeholder]='setLabel("salePrice*PlaceholderLabel")'
                                                name="normalPrice" [(ngModel)]="Product.normalPrice"
                                                oninput="this.value=Math.max(0,this.value);"
                                                [ngClass]="NormalPrice.invalid && (NormalPrice.dirty || NormalPrice.touched) ? 'errorInput' : '' "
                                                #NormalPrice="ngModel" required>
                                          </div>
                                       </div>
                                       <div *ngIf="!paymentModeTaxPos" class="p-g-12">
                                          <div class="p-inputgroup">
                                             <span class="p-inputgroup-addon" [pTooltip]='setLabel("gSTTooltipLabel")'
                                                tooltipPosition="top"><i class="fa fa-money"
                                                   aria-hidden="true"></i></span>
                                             <input type="number" id="gst" autocomplete="off"
                                                [placeholder]='setLabel("gST*PlaceholderLabel")' name="gst"
                                                [(ngModel)]="Product.gstOnProduct"
                                                oninput="this.value=Math.max(0,this.value);"
                                                [ngClass]="gst.invalid && (gst.dirty || gst.touched) ? 'errorInput' : '' "
                                                #gst="ngModel" >
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </form>
                              <div *ngIf="selectedProductType == 'Ingredients Based'"
                                 class="Purchase-Order-Responsive p-g">
                                 <h3 class="first">{{setLabel("ingredientsLabel")}} <span style="color: red;">*</span>
                                 </h3>
                                 <div class="p-g-12 p-table-tecfolk-fix">
                                    <div class="card card-w-title ">
                                       <div>
                                          <p-table [value]="orderProduct" [paginator]="false" [rows]="10"
                                             [responsive]="true">
                                             <ng-template pTemplate="caption" style="text-align: left">

                                                <input id="searchProduct" #searchProduct *ngIf="!isFulFil"
                                                   autocomplete="off" pinputtext=""
                                                   [placeholder]='setLabel("searchProductByNamePlaceholderLabel")'
                                                   type="text" name="name" [(ngModel)]="product.name"
                                                   (click)="op.toggle($event)"
                                                   (keyup)="searchPanelProducts($event, product.name, 'name')"
                                                   class="ng-pristine ng-valid ng-touched">

                                                <p-overlayPanel #op id="op" [dismissable]="true">
                                                   <div class="p-table-tecfolk-fix" style="width: 500px;">
                                                      <p-table [value]="productsInPanel" selectionMode="single"
                                                         [paginator]="true" [rows]="5" [responsive]="true"
                                                         (onRowSelect)="onProductRowSelect($event, op)"
                                                         [(selection)]="selectProduct" id="opPtable" #opPtable
                                                         [first]="first" (onPage)="onPageChange($event)">

                                                         <ng-template pTemplate="header">
                                                            <tr>
                                                               <th>{{setLabel("codeLabel")}}</th>
                                                               <th>{{setLabel("imageLabel")}}</th>
                                                               <th>{{setLabel("itemLabel")}}</th>
                                                               <th>{{setLabel("inStockLabel")}}</th>
                                                               <th>{{setLabel("unitLabel")}}</th>
                                                            </tr>
                                                         </ng-template>

                                                         <ng-template pTemplate="body" let-perm let-rowIndex="rowIndex">
                                                            <tr [pSelectableRow]="perm" id="opRowIds-{{rowIndex}}"
                                                               class="opSelectedRow">
                                                               <td style="color: #000000;">{{perm.code}}</td>
                                                               <td style="color: #000000;">
                                                                  <a>
                                                                     <img [alt]="" src="{{perm.imagePath}}" width="30"
                                                                        style="vertical-align: middle" />
                                                                  </a>
                                                               </td>
                                                               <td style="color: #000000;">{{perm.name}}</td>
                                                               <td style="color: #000000;">{{perm.totalQuantity}}</td>
                                                               <td style="color: #000000;">{{perm.unit}}</td>
                                                            </tr>
                                                         </ng-template>

                                                         <ng-template pTemplate="emptymessage" let-columns>
                                                            <tr style="color: black;">
                                                               <td>
                                                                  {{setLabel("noRecordsFoundLabel")}}
                                                               </td>
                                                            </tr>
                                                         </ng-template>

                                                      </p-table>
                                                   </div>
                                                </p-overlayPanel>
                                             </ng-template>

                                             <ng-template pTemplate="header">
                                                <tr>
                                                   <th style="max-width: 130px;">{{setLabel("actionLabel")}}</th>
                                                   <!-- <th style="max-width: 90px;">Code</th> -->
                                                   <th style="max-width: 130px;">{{setLabel("itemLabel")}}</th>
                                                   <th style="max-width: 130px;">{{setLabel("quantityLabel")}}</th>
                                                   <th style="max-width: 130px;">{{setLabel("unitLabel")}}</th>
                                                   <th style="max-width: 130px;">{{setLabel("baseQuantityLabel")}}</th>
                                                   <th style="max-width: 130px;">{{setLabel("basePriceLabel")}}</th>

                                                </tr>
                                             </ng-template>

                                             <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
                                                <tr class="search-Product-tr">
                                                   <td>
                                                      <div class="mobile-Lable">{{setLabel("actionLabel")}}</div>
                                                      <button pButton (click)="removeSelectedProduct(rowData)"
                                                         type="button" [pTooltip]='setLabel("removeTooltipLabel")'
                                                         [disabled]="isFulFil" icon="fa fa-times"
                                                         style="margin-right: 5px; color: #ffffff; background-color: #F44336;">
                                                      </button>
                                                   </td>
                                                   <td>

                                                      <div class="mobile-Lable">{{setLabel("itemLabel")}}</div>
                                                      {{rowData.name}}
                                                   </td>
                                                   <td>
                                                      <div class="mobile-Lable">{{setLabel("quantityLabel")}}</div>

                                                      <input style="width: 75%;" id="rowQuantity-{{rowIndex}}"
                                                         pinputtext="" autocomplete="off" type="number"
                                                         name="quantity_{{rowIndex}}"
                                                         class="p-corner-all p-state-default p-widget"
                                                         [(ngModel)]="rowData.quantity" min="1"
                                                         (ngModelChange)="quantityChangeEvent(rowData, 'quantity')"
                                                         [disabled]="isFulFil"
                                                         (keyup)="quantityChangeEvent(rowData,'quantity')">
                                                   </td>

                                                   <!-- <td>
                                                      <div class="mobile-Lable">Unit</div>
                                                         <div class="p-g p-fluid" >
                                                            <div class="p-g-12">
                                                               <div class="p-inputgroup">
                                                                   <span class="p-inputgroup-addon" [pTooltip]='setLabel("unitTooltipLabel")' tooltipPosition="top">
                                                                       <i class="fa fa-list" aria-hidden="true"></i>
                                                                   </span>
                                                                   <p-dropdown id="rowUnit-{{rowIndex}}" [(ngModel)]="rowData.unit"
                                                                    name="productUnit_{{rowIndex}}" [options]="sourceUnits"[style]="{'width':'141%','font-size':'14px'}" optionLabel="label"
                                                                    optionValue="value" appendTo="body" placeholder="Select the Unit">
                                                                   </p-dropdown>
                                                               </div>
                                                           </div>
                                                         </div>
                                                   </td>  -->
                                                   <td>
                                                      <div class="mobile-Lable">{{setLabel("unitLabel")}}</div>
                                                      {{rowData.unit}}
                                                   </td>
                                                   <td>
                                                      <div class="mobile-Lable">{{setLabel("baseQuantityLabel")}}</div>

                                                      <input style="width: 75%;" id="rowBaseQuantity-{{rowIndex}}"
                                                         pinputtext="" autocomplete="off" type="number"
                                                         name="basequantity_{{rowIndex}}"
                                                         class="p-corner-all p-state-default p-widget"
                                                         [(ngModel)]="rowData.baseQuantity" min="1"
                                                         (ngModelChange)="quantityChangeEvent(rowData, 'quantity')"
                                                         [disabled]="isFulFil">
                                                   </td>
                                                   <td>
                                                      <div class="mobile-Lable">{{setLabel("basePriceLabel")}}</div>

                                                      <input style="width: 75%;" id="rowBasePrice-{{rowIndex}}"
                                                         pinputtext="" autocomplete="off" type="number"
                                                         name="baseprice_{{rowIndex}}"
                                                         class="p-corner-all p-state-default p-widget"
                                                         [(ngModel)]="rowData.basePrice" min="1"
                                                         (ngModelChange)="quantityChangeEvent(rowData, 'quantity')"
                                                         [disabled]="isFulFil">
                                                   </td>
                                                </tr>
                                             </ng-template>

                                             <ng-template pTemplate="emptymessage" let-columns>
                                                <tr>
                                                   <td>
                                                      {{setLabel("noProductAddedLabel")}}
                                                   </td>
                                                </tr>
                                             </ng-template>


                                          </p-table>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div style="clear: both;"></div>
                        </div>
                     </p-tabPanel>

                     <p-tabPanel [header]='setLabel("extraInfoLabel")' leftIcon=" fa fa-pencil">
                        <div class="card card-w-title">
                           <div class="p-g-12">
                              <form class="ExtraInfo" #addEditProductsFormExtraInfo="ngForm">
                                 <div class="p-g-12 p-md-6" style="text-align: left">
                                    <div class="p-g p-fluid">

                                       <h3 class="first">{{setLabel("storageInfoLabel")}} </h3>
                                       <div class="p-g-12">
                                          <div class="p-inputgroup">
                                             <span class="p-inputgroup-addon"
                                                [pTooltip]='setLabel("barcodeTooltipLabel")' tooltipPosition="top"><i
                                                   class="fa fa-barcode" aria-hidden="true"></i></span>
                                             <input type="text" id="barcode" #barcode
                                                [placeholder]='setLabel("barcodePlaceholderLabel")'
                                                [(ngModel)]="Product.barcode" name="barcode">
                                          </div>
                                       </div>

                                       <div class="p-g-12">
                                          <div class="p-inputgroup">
                                             <span class="p-inputgroup-addon"
                                                [pTooltip]='setLabel("reorderPointTooltipLabel")'
                                                tooltipPosition="top"><i class="fa fa-bars"
                                                   aria-hidden="true"></i></span>
                                             <input type="number"
                                                [placeholder]='setLabel("reorderPointPlaceholderLabel")'
                                                id="reorderPoint" [(ngModel)]="Product.reOrderLevel"
                                                name="reorderPoint">
                                          </div>
                                       </div>

                                       <div class="p-g-12">
                                          <div class="p-inputgroup">
                                             <span class="p-inputgroup-addon"
                                                [pTooltip]='setLabel("reorderQuantityTooltipLabel")'
                                                tooltipPosition="top"><i class="fa fa-bars"
                                                   aria-hidden="true"></i></span>
                                             <input type="number"
                                                [placeholder]='setLabel("reorderQuantityPlaceholderLabel")'
                                                id="reorderQuantity" [(ngModel)]="Product.reOrderQuantity"
                                                name="reorderQuantity">
                                          </div>
                                       </div>

                                       <!-- <div class="p-g-12">
                                          <div class="p-inputgroup" style="display: flex;">
                                             <span class="p-inputgroup-addon" pTooltip="Default Location"
                                             tooltipPosition="top"><i class="fa fa-map-marker"
                                                   aria-hidden="true"></i></span>
                                             &nbsp;&nbsp;&nbsp;
                                             <p-dropdown class="dropdownFull" required="required" appendTo="body"
                                                name="defaultLocation" [style]="{'width':'100%'}">
                                             </p-dropdown>
                                          </div>
                                       </div> -->
                                    </div>
                                 </div>

                                 <div class="p-g-12 p-md-6" style="text-align: left">
                                    <h3 class="first">{{setLabel("remarksLabel")}}</h3>
                                    <div class="p-g p-fluid">
                                       <div class="p-g-12">
                                          <div class="p-inputgroup">
                                             <span class="p-inputgroup-addon"
                                                [pTooltip]='setLabel("remarksTooltipLabel")' tooltipPosition="top"><i
                                                   class="fa fa-pencil-square-o" aria-hidden="true"></i></span>
                                             <textarea rows="7" cols="67" name="remarks" [(ngModel)]="Product.remarks"
                                                [placeholder]='setLabel("remarksPlaceholderLabel")'
                                                id="remarks"></textarea>
                                          </div>
                                       </div>
                                    </div>

                                 </div>
                              </form>
                           </div>
                           <div style="clear: both;"></div>
                        </div>
                     </p-tabPanel>

                     <p-tabPanel [header]='setLabel("addedStockLabel")'
                        *ngIf="mode == 'edit' && selectedProductType !== 'Ingredients Based'" leftIcon=" fa fa-cubes">
                        <div class="p-g">
                           <div class="p-g-12 p-table-tecfolk-fix">
                              <p-table [value]="stocks" [paginator]="true" [rows]="10" [responsive]="true"
                                 [loading]="loading">
                                 <ng-template pTemplate="header">
                                    <tr>
                                       <th style="max-width: 90px;">{{setLabel("stockQuantityLabel")}}</th>
                                       <th style="max-width: 90px;">{{setLabel("purchasePriceLabel")}}</th>
                                       <th style="max-width: 90px;">{{setLabel("wholesalePriceLabel")}}</th>
                                       <th style="max-width: 90px;">{{setLabel("salePriceLabel")}}</th>
                                       <th style="max-width: 90px;">{{setLabel("stockTotalPaymentLabel")}}</th>
                                       <th style="max-width: 90px;">{{setLabel("stockPaymentModeLabel")}}</th>
                                       <th style="max-width: 90px;">{{setLabel("stockAddedDateLabel")}}</th>
                                       <!-- <th style="max-width: 130px; text-align: center;">Action</th> -->
                                    </tr>
                                 </ng-template>
                                 <ng-template pTemplate="body" let-rowData>
                                    <tr>
                                       <td *ngIf="rowData.stockQuantityAdded != 0" class="add-product-td">
                                          <div class="mobile-lable">{{setLabel("stockQuantityLabel")}}</div>
                                          {{rowData.stockQuantityAdded}}
                                       </td>
                                       <td *ngIf="rowData.stockQuantityAdded != 0"
                                          class="add-product-td">
                                          <div class="mobile-lable">{{setLabel("purchasePriceLabel")}}</div>
                                          {{rowData.purchasePrice | number:'1.0-0'}}
                                       </td>
                                       <td *ngIf="rowData.stockQuantityAdded != 0"
                                          class="add-product-td">
                                          <div class="mobile-lable">{{setLabel("wholesalePriceLabel")}}</div>
                                          {{rowData.wholesalePrice | number:'1.0-0'}}
                                       </td>
                                       <td *ngIf="rowData.stockQuantityAdded != 0"
                                          class="add-product-td">
                                          <div class="mobile-lable">{{setLabel("salePriceLabel")}}</div>
                                          {{rowData.salePrice | number:'1.0-0'}}
                                       </td>
                                       <td *ngIf="rowData.stockQuantityAdded != 0"
                                          class="add-product-td">
                                          <div class="mobile-lable">{{setLabel("stockTotalPaymentLabel")}}</div>
                                          {{rowData.totalPayment | number:'1.0-0'}}
                                       </td>
                                       <td *ngIf="rowData.stockQuantityAdded != 0"
                                          class="add-product-td">
                                          <div class="mobile-lable">{{setLabel("stockPaymentModeLabel")}}</div>
                                          {{rowData.paymentMode}}
                                       </td>
                                       <td *ngIf="rowData.stockQuantityAdded != 0" class="add-product-td">
                                          <div class="mobile-lable">{{setLabel("dateLabel")}}</div>
                                          {{rowData.createdOn | date: 'medium'}}
                                       </td>
                                       <!-- <td style="text-align: center;">
                                          <button style="color:white; background-color: #2b6bbe; margin-right: 8px;"
                                             class="p-button p-widget p-state-default p-corner-all p-button-text-only">
                                             <i class="fa fa-pencil-square-o" style="margin-right: 8px;"></i> Edit
                                          </button>

                                          <button pButton type="button" pTooltip="Edit" icon="fa fa-pencil-square-o"
                                             (click)="viewStock(rowData)" style="margin-right: 5px;">
                                          </button>
                                       </td> -->
                                    </tr>
                                 </ng-template>
                              </p-table>
                           </div>
                        </div>
                     </p-tabPanel>
                     <p-tabPanel [header]='setLabel("removedStockLabel")'
                        *ngIf="mode == 'edit' && selectedProductType !== 'Ingredients Based'" leftIcon=" fa fa-cubes">
                        <div class="p-g">
                           <div class="p-g-12 p-table-tecfolk-fix">
                              <p-table [value]="stocks" [paginator]="true" [rows]="10" [responsive]="true"
                                 [loading]="loading">
                                 <ng-template pTemplate="header">
                                    <tr>
                                       <th style="max-width: 90px;">{{setLabel("stockQuantityLabel")}}</th>
                                       <th *ngIf="selectedProductType == 'Ready to Sell'" style="max-width: 90px;">
                                          {{setLabel("purchasePriceLabel")}}</th>
                                       <th *ngIf="selectedProductType == 'Ready to Sell'" style="max-width: 90px;">
                                          {{setLabel("wholesalePriceLabel")}}</th>
                                       <th *ngIf="selectedProductType == 'Ready to Sell'" style="max-width: 90px;">
                                          {{setLabel("salePriceLabel")}}</th>
                                       <th style="max-width: 90px;">{{setLabel("commentLabel")}}</th>
                                       <th style="max-width: 90px;">{{setLabel("stockRemovedDateLabel")}}</th>
                                       <!-- <th style="max-width: 130px; text-align: center;">Action</th> -->
                                    </tr>
                                 </ng-template>
                                 <ng-template pTemplate="body" let-rowData>
                                    <tr>
                                       <td *ngIf="rowData.stockQuantityRemoved != 0" class="add-product-td">
                                          <div class="mobile-lable">{{setLabel("stockQuantityLabel")}}</div>
                                          {{rowData.stockQuantityRemoved}}
                                       </td>
                                       <td *ngIf="rowData.stockQuantityRemoved != 0"
                                          class="add-product-td">
                                          <div class="mobile-lable">{{setLabel("purchasePriceLabel")}}</div>
                                          {{rowData.purchasePrice | number:'1.0-0'}}
                                       </td>
                                       <td *ngIf="rowData.stockQuantityRemoved != 0"
                                          class="add-product-td">
                                          <div class="mobile-lable">{{setLabel("wholesalePriceLabel")}}</div>
                                          {{rowData.wholesalePrice | number:'1.0-0'}}
                                       </td>
                                       <td *ngIf="rowData.stockQuantityRemoved != 0"
                                          class="add-product-td">
                                          <div class="mobile-lable">{{setLabel("salePriceLabel")}}</div>
                                          {{rowData.salePrice | number:'1.0-0'}}
                                       </td>
                                       <td *ngIf="rowData.stockQuantityRemoved != 0" class="add-product-td">
                                          <div class="mobile-lable">{{setLabel("commentLabel")}}</div>
                                          {{rowData.comment}}
                                       </td>
                                       <td *ngIf="rowData.stockQuantityRemoved != 0" class="add-product-td">
                                          <div class="mobile-lable">{{setLabel("dateLabel")}}</div>
                                          {{rowData.createdOn | date: 'medium'}}
                                       </td>
                                       <!-- <td style="text-align: center;">
                                          <button style="color:white; background-color: #2b6bbe; margin-right: 8px;"
                                             class="p-button p-widget p-state-default p-corner-all p-button-text-only">
                                             <i class="fa fa-pencil-square-o" style="margin-right: 8px;"></i> Edit
                                          </button>

                                          <button pButton type="button" pTooltip="Edit" icon="fa fa-pencil-square-o"
                                             (click)="viewStock(rowData)" style="margin-right: 5px;">
                                          </button>
                                       </td> -->
                                    </tr>
                                 </ng-template>
                              </p-table>
                           </div>
                        </div>
                     </p-tabPanel>
                  </p-tabView>
               </form>
            </div>
         </div>
      </p-tabView>
   </div>

   <div *ngIf="dialogVisibility">
      <p-dialog [header]='setLabel("addProductImageLabel")' [(visible)]="dialogVisibility">
         <app-add-profile-image [popupType]="addProfileImage" (closeThePopup)="hideAddProfileImage()"
            (outputImage)="handleImagefromNewProfile($event)"></app-add-profile-image>
      </p-dialog>
   </div>

   <p-dialog [(visible)]="showAddStockBox" [closeOnEscape]="true" [focusOnShow]="false"
      styleClass="add-stock-dialog" [style]="{width: '67vw', left:'5%', top:'10px'}">
      <p-header>
         {{setLabel("addStockLabel")}}
      </p-header>
      <form #stockForm="ngForm">
         <div class="stock-form-container" style="display: grid;">

            <div style="display: flex;
            flex-direction: column;" class="p-g-12 Stock-Info-Main ">
               <div class="p-g-12 p-md-6">
                  <div class="p-g p-fluid">

                     <h3 class="Stock-Info-Heading first">{{setLabel("stockInfoLabel")}} </h3>
                     <div *ngIf="selectedProductType !== 'Ready to Sell'" class="p-g-12">
                        <div class="p-inputgroup">
                           <span class="stock-info-span p-inputgroup-addon p-g-4"
                              style="text-align: start;font-weight: 900;" [pTooltip]='setLabel("unitTooltipLabel")'
                              tooltipPosition="top">{{setLabel("unitLabel")}}</span>
                           <div class="p-g p-fluid">
                              <div class="p-g-12">
                                 <div class="p-inputgroup">
                                    <span class="p-inputgroup-addon" [pTooltip]='setLabel("unitTooltipLabel")'
                                       tooltipPosition="top">
                                       <i class="fa fa-list" aria-hidden="true"></i>
                                    </span>
                                    <p-dropdown id="rowUnit-{{rowIndex}}" [(ngModel)]="Product.unit"
                                       name="productUnit_{{rowIndex}}" [options]="sourceUnits"
                                       [style]="{'width':'141%','font-size':'14px'}" optionLabel="label"
                                       optionValue="value" appendTo="body"
                                       [placeholder]='setLabel("selecttheUnitPlaceholderLabel")'>
                                    </p-dropdown>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div class="p-g-12">
                        <div class="p-inputgroup">
                           <span class="stock-info-span p-inputgroup-addon p-g-4"
                              style="text-align: start;font-weight: 900;"
                              [pTooltip]='setLabel("enterStockTooltipLabel")'
                              tooltipPosition="top">{{setLabel("enterStockLabel")}}</span>
                           <input type="number" [placeholder]='setLabel("enterStockPlaceholderLabel")'
                              [(ngModel)]="stock.stockQuantityAdded"
                              (keyup)="countTotalStockQuantity(stock.stockQuantityAdded)" name="enterdStock"
                              oninput="this.value=Math.max(0,this.value);">
                        </div>
                     </div>

                     <div class="p-g-12">
                        <div class="p-inputgroup">
                           <span class="stock-info-span p-inputgroup-addon p-g-4"
                              style="text-align: start;font-weight: 900;"
                              [pTooltip]='setLabel("existingStockTooltipLabel")'
                              tooltipPosition="top">{{setLabel("existingStockLabel")}}</span>
                           <input type="number" readonly [placeholder]='setLabel("existingStockPlaceholderLabel")'
                              [(ngModel)]="Product.totalQuantity" name="totalProductQuantity">
                        </div>
                     </div>

                     <div class="p-g-12">
                        <div class="p-inputgroup">
                           <span class="stock-info-span p-inputgroup-addon p-g-4"
                              style="text-align: start;font-weight: 900;"
                              [pTooltip]='setLabel("totalStockTooltipLabel")'
                              tooltipPosition="top">{{setLabel("totalStockLabel")}}</span>
                           <input type="number" readonly [placeholder]='setLabel("totalStockPlaceholderLabel")'
                              [(ngModel)]="productStockTotalQuantity" name="totalStockQuantity">
                        </div>
                     </div>

                  </div>
               </div>

               <div class="p-g-12 p-md-6">
                  <div class="p-g p-fluid">

                     <h3 class="Stock-Pricing-Heading first">{{setLabel("stockPricingLabel")}} </h3>
                     <div class="p-g-12">
                        <div class="p-inputgroup">
                           <span class="stock-info-span p-inputgroup-addon p-g-4"
                              style="text-align: start;font-weight: 900;"
                              [pTooltip]='setLabel("wholesalePriceTooltipLabel")'
                              tooltipPosition="top">{{setLabel("wholesalePriceLabel")}}</span>
                           <input type="number" [placeholder]='setLabel("wholesalePricePlaeholderLabel")'
                              [(ngModel)]="stock.wholesalePrice" name="wholesalePrice"
                              oninput="this.value=Math.max(0,this.value);">
                        </div>
                     </div>

                     <div class="p-g-12">
                        <div class="p-inputgroup">
                           <span class="stock-info-span p-inputgroup-addon p-g-4"
                              style="text-align: start;font-weight: 900;"
                              [pTooltip]='setLabel("purchasePriceTooltipLabel")'
                              tooltipPosition="top">{{setLabel("purchasePriceLabel")}}</span>
                           <input type="number" [placeholder]='setLabel("purchasePricePlaeholderLabel")'
                              [(ngModel)]="stock.purchasePrice" name="purchasePrice"
                              oninput="this.value=Math.max(0,this.value);">
                        </div>
                     </div>

                     <div class="p-g-12">
                        <div class="p-inputgroup">
                           <span class="stock-info-span p-inputgroup-addon p-g-4"
                              style="text-align: start;font-weight: 900;" [pTooltip]='setLabel("salePriceTooltipLabel")'
                              tooltipPosition="top">{{setLabel("salePriceLabel")}}</span>
                           <input type="number" [placeholder]='setLabel("salePricePlacderLabel")'
                              [(ngModel)]="stock.salePrice" name="salePrice"
                              oninput="this.value=Math.max(0,this.value);">
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            <div class="stock-payment-row" style="display: flex; justify-content: space-between; padding: 0px 30px;">
               <div class="p-g-6" style="padding: 0, 20px">
                  <h3 class="first">{{setLabel("paymentBankLabel")}}</h3>
                  <div style="display:flex; gap:30px; align-items: center;">
                      <span class="p-inputgroup-addon"><i class="fa fa-bank" aria-hidden="true"></i></span>
                      <p-dropdown class="p-g-8" [options]="paymentModes"
                          (onChange)="onPaymentModeChange($event.value)"></p-dropdown>
                  </div>

               </div>

               <div class="p-g-6 p-inputgroup">
               <span class="stock-info-span p-inputgroup-addon p-g-4"
                  style="text-align: start;font-weight: 900;" [pTooltip]='setLabel("TotalPaymentTooltipLabel")'
                  tooltipPosition="top">{{setLabel("TotalPaymentLabel")}}</span>
               <input type="number" [placeholder]='setLabel("salePricePlacderLabel")'
                  [(ngModel)]="totalPayment" name="totalPayment"
                  oninput="this.value=Math.max(0,this.value);">
                        </div>
            </div>

            <div style="display: flex;justify-content: center; gap:30px; margin-top: 3%;">
               <button (click)="closeAddStockBox()" pButton type="button"
                  class="p-button p-widget p-state-default p-corner-all" [label]='setLabel("cancelBtnLabel")'
                  style="background-color: gray;">
               </button>
               <button [disabled]="!stockForm.valid" pButton type="button"
                  class="p-button p-widget p-state-default p-corner-all" [label]='setLabel("saveBtnLabel")'
                  (click)="saveStock()" class="p-button-success "></button>
            </div>
         </div>
      </form>
   </p-dialog>
   <p-dialog [(visible)]="showRemoveStockBox" [closeOnEscape]="true" [focusOnShow]="false"
      styleClass="add-stock-dialog" [style]="{width: '67vw', left:'5%', top:'10px'}">
      <p-header>
         {{setLabel("removeStockLabel")}}
      </p-header>
      <form #stockForm="ngForm">
         <div class="stock-form-container" style="display: grid;">

            <div style="display: flex;
            flex-direction: column;" class="p-g-12 Stock-Info-Main ">
               <div class="p-g-12 p-md-6">
                  <div class="p-g p-fluid">

                     <h3 class="Stock-Info-Heading first">{{setLabel("stockInfoLabel")}} </h3>
                     <div *ngIf="selectedProductType !== 'Ready to Sell'" class="p-g-12">
                        <div class="p-inputgroup">
                           <span class="stock-info-span p-inputgroup-addon p-g-4"
                              style="text-align: start;font-weight: 900;" [pTooltip]='setLabel("unitTooltipLabel")'
                              tooltipPosition="top">{{setLabel("unitLabel")}}</span>
                           <div class="p-g p-fluid">
                              <div class="p-g-12">
                                 <div class="p-inputgroup">
                                    <span class="p-inputgroup-addon" [pTooltip]='setLabel("unitTooltipLabel")'
                                       tooltipPosition="top">
                                       <i class="fa fa-list" aria-hidden="true"></i>
                                    </span>
                                    <p-dropdown id="rowUnit-{{rowIndex}}" [(ngModel)]="Product.unit"
                                       name="productUnit_{{rowIndex}}" [options]="sourceUnits"
                                       [style]="{'width':'141%','font-size':'14px'}" optionLabel="label"
                                       optionValue="value" appendTo="body"
                                       [placeholder]='setLabel("selectTheUnitPlaceholderLabel")'>
                                    </p-dropdown>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div class="p-g-12">
                        <div class="p-inputgroup">
                           <span class="stock-info-span p-inputgroup-addon p-g-4"
                              style="text-align: start;font-weight: 900;"
                              [pTooltip]='setLabel("enterStockTooltipLabel")'
                              tooltipPosition="top">{{setLabel("enterStockLabel")}}</span>
                           <input type="number" [placeholder]='setLabel("enterStockPlaceholderLabel")'
                              [(ngModel)]="stock.stockQuantityRemoved"
                              (keyup)="removeTotalStockQuantity(stock.stockQuantityRemoved)" name="enterdStock"
                              oninput="this.value=Math.max(0,this.value);">
                        </div>
                        <div *ngIf="stock.stockQuantityRemoved > Product.totalQuantity" class="errorShow">
                           {{setLabel("enteredStockErrorLabel")}}
                        </div>
                        </div>

                     <div class="p-g-12">
                        <div class="p-inputgroup">
                           <span class="stock-info-span p-inputgroup-addon p-g-4"
                              style="text-align: start;font-weight: 900;"
                              [pTooltip]='setLabel("existingStockTooltipLabel")'
                              tooltipPosition="top">{{setLabel("existingStockLabel")}}</span>
                           <input type="number" readonly [placeholder]='setLabel("existingStockPlaceholderLabel")'
                              [(ngModel)]="Product.totalQuantity" name="totalProductQuantity">
                        </div>
                     </div>

                     <div class="p-g-12">
                        <div class="p-inputgroup">
                           <span class="stock-info-span p-inputgroup-addon p-g-4"
                              style="text-align: start;font-weight: 900;"
                              [pTooltip]='setLabel("totalStockTooltipLabel")'
                              tooltipPosition="top">{{setLabel("totalStockLabel")}}</span>
                           <input type="number" readonly [placeholder]='setLabel("totalStockPlaceholderLabel")'
                              [(ngModel)]="productStockTotalQuantity" name="totalStockQuantity">
                        </div>
                     </div>
                     <div class="p-g-12">
                        <div class="p-inputgroup">
                           <span class="stock-info-span p-inputgroup-addon p-g-4"
                              style="text-align: start;font-weight: 900;" [pTooltip]='setLabel("commentTooltipLabel")'
                              tooltipPosition="top">{{setLabel("reasonForRemovalLabel")}}</span>
                           <input type="text" [placeholder]='setLabel("commentPlaceholderLabel")'
                              [(ngModel)]="stock.comment" name="removalReason">
                        </div>
                     </div>

                  </div>
               </div>

               <div *ngIf="selectedProductType !== 'Ingredients'" class="p-g-12 p-md-6">
                  <div class="p-g p-fluid">

                     <h3 class="Stock-Pricing-Heading first">{{setLabel("stockPricingLabel")}} </h3>
                     <div class="p-g-12">
                        <div class="p-inputgroup">
                           <span class="stock-info-span p-inputgroup-addon p-g-4"
                              style="text-align: start;font-weight: 900;"
                              [pTooltip]='setLabel("wholesalePriceTooltipLabel")'
                              tooltipPosition="top">{{setLabel("wholesalePriceLabel")}}</span>
                           <input type="number" [placeholder]='setLabel("wholesalePricePlaceholceholderLabel")'
                              [(ngModel)]="stock.wholesalePrice" name="wholesalePrice"
                              oninput="this.value=Math.max(0,this.value);">
                        </div>
                     </div>

                     <div class="p-g-12">
                        <div class="p-inputgroup">
                           <span class="stock-info-span p-inputgroup-addon p-g-4"
                              style="text-align: start;font-weight: 900;"
                              [pTooltip]='setLabel("purchasePriceTooltipLabel")'
                              tooltipPosition="top">{{setLabel("purchasePriceLabel")}}</span>
                           <input type="number" [placeholder]='setLabel("purchasePricePlaceholderLabel")'
                              [(ngModel)]="stock.purchasePrice" name="purchasePrice"
                              oninput="this.value=Math.max(0,this.value);">
                        </div>
                     </div>

                     <div class="p-g-12">
                        <div class="p-inputgroup">
                           <span class="stock-info-span p-inputgroup-addon p-g-4"
                              style="text-align: start;font-weight: 900;" [pTooltip]='setLabel("salePriceTooltipLabel")'
                              tooltipPosition="top">{{setLabel("salePriceLabel")}}</span>
                           <input type="number" [placeholder]='setLabel("salePricePlaceholderLabel")'
                              [(ngModel)]="stock.salePrice" name="salePrice"
                              oninput="this.value=Math.max(0,this.value);">
                        </div>
                     </div>

                  </div>
               </div>
            </div>
            <div style="display: flex;justify-content: center; gap:30px; margin-top: 3%;">
               <button (click)="closeRemoveStockBox()" pButton type="button"
                  class="p-button p-widget p-state-default p-corner-all" [label]='setLabel("cancelBtnLabel")'
                  style="background-color: gray;">
               </button>
               <button [disabled]="!stockForm.valid || stock.stockQuantityRemoved > Product.totalQuantity" pButton type="button"
                  [ngClass]="{'save-success ': stock.stockQuantityRemoved < Product.totalQuantity, 'save-secondary': stock.stockQuantityRemoved > Product.totalQuantity }"
                  class="p-button p-widget p-state-default p-corner-all" [label]='setLabel("saveBtnLabel")'
                  (click)="removeStock()" class="p-button-success "></button>
            </div>
         </div>
      </form>
   </p-dialog>

</div>